import "./styles.scss";
import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";
const SimpleCard = ({
  url,
  image,
  icon,
  title,
  description,
  aside,
  variant,
  isBorderless,
  isEqual,
  size,
  isActive,
  onClick,
}) => {
  const Type = url ? Link : onClick ? "button" : "div";
  return (
    <Type
      className={clsx(
        "simple-card",
        variant && `simple-card--${variant}`,
        url && "simple-card--link",
        image && isBorderless && "simple-card--borderless",
        !image && !icon && "simple-card--compact",
        icon && "simple-card--icon",
        isEqual && "simple-card--equal",
        size && `simple-card--${size}`,
        isActive && `simple-card--is-active`
      )}
      onClick={onClick}
      to={url}
    >
      {(image || icon) && (
        <div className="simple-card__thumbnail">
          {typeof image === "string" || icon ? (
            <div className="simple-card__thumbnail-inner">
              <img src={image ?? icon} alt={title} />
            </div>
          ) : (
            <img src={image} alt={title} />
          )}
          {url && (
            <div className="simple-card__thumbnail-arrow">
              <img
                src={require("assets/icons/arrow-right--new.svg").default}
                alt=""
              />
            </div>
          )}
        </div>
      )}
      <div className="simple-card__body">
        <div className="simple-card__body__header">
          <h3>{title}</h3>
        </div>
        {(image || icon) && description && (
          <div
            className={clsx(
              "simple-card__body__description",
              !!aside && "simple-card__body__description--aside"
            )}
          >
            <p>{description}</p>
            {!!aside && <small>{aside}</small>}
          </div>
        )}
      </div>
    </Type>
  );
};
export default SimpleCard;
